import { AgentDatasetSchema } from "@redotech/redo-model/agents/agent-dataset";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createAgentDataset = {
  name: "createAgentDataset" as const,
  input: z.object({
    name: z.string(),
    description: z.string().optional(),
    agentName: z.string(),
    team: zExt.objectId(),
    createdBy: zExt.objectId(),
  }),
  output: AgentDatasetSchema,
};
